import { Component, type ReactNode } from 'react';

type Props = { children: ReactNode; onError?: () => void };

/**
 * The alert center and the bell sit outside the page's error boundary: a failure there must not
 * take the rest of Hub down with it (and come back on every reload). It renders nothing instead.
 */
export class AlertCenterBoundary extends Component<Props, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  override componentDidCatch(error: unknown) {
    console.error('Hub alert center failed', error);
    this.props.onError?.();
  }

  override render() {
    return this.state.failed ? null : this.props.children;
  }
}
